module.exports = __webpack_public_path__ + "static/embark-1402d4f99385fd5f6c24691d198c4bb3.png";